<template lang="pug">
router-link.WorkHeading(v-if="isLink" :to="{ name: 'client', params: { slug: data.slug }}"): span.inner {{ data.client }}
h1.WorkHeading(v-else): span.inner: slot
</template>

<script>
import { lerp } from '@/assets/scripts/utils.js'
import { TweenLite, Power4 } from 'gsap'

export default {
  name: 'WorkHeading',
  props: ['data'],
  data() {
    return {
      isLink: this.$props.data && this.$props.data.slug,
      mouseX: 0,
      transform: 0
    }
  },
  methods: {
    onMouseMove(e) {
      const left = this.$el.getBoundingClientRect().x
      const containerWidth = window.innerWidth - left
      const perc =
        ((e.clientX - left) / (containerWidth * 0.8)) *
        Math.min(
          0,
          containerWidth -
            this.$el.querySelector('.inner').getBoundingClientRect().width
        )
      this.mouseX = perc
    },
    animate() {
      const inner = this.$el.querySelector('.inner')
      this.transform = lerp(this.transform, this.mouseX, 0.1)

      inner.style.transform = `translate3d(${
        window.innerWidth >= 900 ? this.transform : 0
      }px, 0, 0)`

      requestAnimationFrame(this.animate)
    },
    resetDisplacement() {
      this.mouseX = 0
    }
  },
  mounted() {
    const arrow = this.$el.querySelector('.inner .stays')
    if (arrow) {
      TweenLite.to(arrow, 0.6, {
        autoAlpha: 0,
        display: 'none',
        ease: Power4.easeOut
      })
    }
    this.$el.addEventListener('click', this.resetDisplacement)
    this.$el.addEventListener('mouseleave', this.resetDisplacement)
    this.$el.addEventListener('mousemove', this.onMouseMove)
    this.animate()
  }
}
</script>

<style lang="scss">
.WorkHeading {
  display: block;
  font-size: 2rem;
  margin: 1rem 0;
  font-kerning: none;
  line-height: 1.3em;
  text-decoration: none;
  overflow: hidden;
  color: black;

  @media only screen and (min-width: 780px) and (max-width: 1024px) {
    font-size: 2.6rem;
  }

  @media only screen and (min-width: 1025px) {
    font-size: 6rem;
    white-space: nowrap;
    margin: 0;
  }

  .inner {
    display: inline-block;
    font-weight: bold;

    &:first-letter {
      letter-spacing: 0;
    }
  }
}
</style>
